import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: theme.spacing(2.5, 3),
      width: `calc(50% - ${theme.spacing(1)}px)`,
      border: theme.shape.borderGray70,
      borderRadius: theme.shape.borderRadiusSemiLarge,
      rowGap: theme.spacing(1.5),
      backgroundColor: COLORS.gray.white,
      height: 240,
    },
    header: {
      display: 'flex',
      alignItems: 'center',
    },
    channelIcon: {
      fontSize: theme.typography.pxToRem(24),
      marginRight: theme.spacing(1),
      '& rect': {
        fill: 'transparent',
      },
    },
    checkmarkIcon: {
      marginLeft: 'auto',
      marginRight: theme.spacing(0.5),
      fontSize: theme.typography.pxToRem(16),
      color: COLORS.success.default,
    },
    connected: {
      color: COLORS.success.active,
    },
    betaTag: {
      marginLeft: theme.spacing(1),
      padding: theme.spacing(0.25, 0.75),
      fontSize: theme.typography.pxToRem(11),
      lineHeight: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
      borderRadius: theme.shape.borderRadiusMinimal,
      color: COLORS.gray.gray30,
      backgroundColor: COLORS.gray.gray80,
    },
    description: {
      height: 88,
    },
    connectButton: {
      marginTop: 'auto',
      width: 'fit-content',
    },
  }),
  { name: 'Channel' }
);
